/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PlatformApiResultOfFeedbackUnreadCountDto } from '../../models/platform-api-result-of-feedback-unread-count-dto';

export interface GetFeedbackMineUnreadCount$Params {
}

export function getFeedbackMineUnreadCount(http: HttpClient, rootUrl: string, params?: GetFeedbackMineUnreadCount$Params, context?: HttpContext): Observable<StrictHttpResponse<PlatformApiResultOfFeedbackUnreadCountDto>> {
  const rb = new RequestBuilder(rootUrl, getFeedbackMineUnreadCount.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PlatformApiResultOfFeedbackUnreadCountDto>;
    })
  );
}

getFeedbackMineUnreadCount.PATH = '/api/feedback/mine/unread-count';
